<!--suppress ALL -->
<template>
  <div id="water-print">
    <div class="wp-close">
      <img src="@/assets/img/icons/water-print-close.svg" @click="closeWaterPrint"/>
    </div>
    <div class="wp-main-content">
      <div class="wp-header" v-if="!answersDone">
        <div class="wp-h-title">
          SU AYAK İZİNİ HESAPLA
        </div>
        <div class="wp-h-text">
          Bir kişinin ortalama tükettiği su miktarına su ayak izi denir. Su ayak izinizi hesaplayarak,
          Türkiye’nin 2030 yılında su sorunu yaşamaması için neler yapabileceğinizi görebilirsiniz.
        </div>
      </div>
      <div class="wp-questions-container" v-if="!answersDone">
        <div class="wp-image">
          <img :key="answerIndex"
               :src="require('@/assets/img/water_print_image/'+ answerList[answerIndex].image) "
               :lt="answerList[answerIndex].question"/>
        </div>
        <div class="wp-question">
          {{ answerList[answerIndex].question }}
        </div>
        <div :key="answerIndex" v-if="answerList[answerIndex].type === 'radio'" class="wp-answers">
          <div class="wp-a-radio-container" v-for="input in answerList[answerIndex].answers">
            <input :id="answerList[answerIndex].identifier + input.text"
                   :name="answerList[answerIndex].identifier" :value="input.value"
                   type="radio"
                   @click="pushAnswer(answerList[answerIndex].identifier + input.text, answerIndex)">
            <label :for="answerList[answerIndex].identifier + input.text">{{ input.text }}</label>
          </div>
        </div>
        <div :key="answerIndex" v-if="answerList[answerIndex].type === 'input'" class="wp-answers"
             :class="answerList[answerIndex].identifier">
          <input :id="answerList[answerIndex].identifier" type="number" @change="checkLegitType($event)"/>
        </div>
        <div :key="answerIndex" v-if="answerList[answerIndex].type === 'select'" class="wp-answers">
          <select :id="answerList[answerIndex].identifier"
                  @change="pushAnswer(answerList[answerIndex].identifier, answerIndex)">
            <option value="null">Seçiniz</option>
            <option v-for="option in answerList[answerIndex].answers" :value="option.value">
              {{ option.name }}
            </option>
          </select>
        </div>
        <div class="wp-answer-submit">
          <div class="wp-a-s-button" @click="submitAnswer()"
               :class="{'invalid' : this.invalidInput }">
               
                  İleri »
               <!--<div class="wp-a-s-button-icon wp-a-s-button-icon-right">
                  <img src="@/assets/img/water_print_image/double-arrows-white.svg">
               </div>-->
          </div>
          <div v-if="answerIndex > 0" class="wp-a-s-button" @click="previousQuestion()">
            <!--<div class="wp-a-s-button-icon">
              <img src="@/assets/img/water_print_image/double-arrows.svg">
            </div>-->
            « Geri</div>
        </div>
      </div>
      <div v-if="answersDone && !promiseMade" class="wp-result-container">
        <div class="result">Su Ayak İzin
          <div class="animated heartBeat inline delay-1s">{{ promiseAfter }}</div>
          lt/gün
        </div>
        <div class="wp-promise-form">
          <div v-for="(promiseOption, index) in promiseMadeOptions" class="wp-p-item"
               :ref="promiseOption.id" :key="index"
               :class="promiseOption.display">
            <input type="checkbox" :name="promiseOption.id" :id="promiseOption.id"
                   @change="refreshResult()">
            <span class="checkmark"/>
            <div class="checkbox-cont">
              <p>{{ promiseOption.text }}</p>
              <p>{{ promiseOption.subtext }}</p>
            </div>
          </div>
        </div>
        <div class="wp-promise-submit-container">
          <div class="wp-p-reset" @click="resetWaterPrint">« Baştan Hesapla</div>
          <div id="sen-soz-ver-submit" class="wp-p-submit" @click="promiseShareOptions"
               :class="{'invalid-promise' : promiseInvalid }">SEN DE SÖZ VER
          </div>
        </div>
      </div>
      <div v-if="promiseMade" class="wp-promise-made">
        <div class="wp-p-promise-image">
          <svg version="1.2" xmlns="http://www.w3.org/2000/svg" id="wp-p-promise-image-website">
            <image href="@/assets/img/water_print_image/sendesozver-result.jpg" x="0" y="0"/>
            <text :x="promiseImage().text.x" :y="promiseImage().text.y" fill="white">{{ getShareResult() }}</text>
            <text class="promise-image__description" :x="promiseImage().description.x" :y="promiseImage().description.y" fill="white">{{ getShareResult() }} litre suyu</text>
          </svg>
        </div>
        <div class="wp-p-share-options">
          <ShareNetwork
              :key="index"
              v-for="(shareOption, index) in socialShareOptions"
              class="wp-p-share-option"
              :network="shareOption.network"
              :url="shareUrl"
              :title="shareOption.title"
              :description="getShareDescription"
              :hashtags="shareOption.hashtags"
          >
            <div :class="shareOption.button.class">
              <img :src="shareOption.button.image">
              <div class="share-text">PAYLAŞ</div>
            </div>
          </ShareNetwork>
          <a class="wp-p-share-option share-network-instagram" href="javascript:void(0)" @click="instagramShare">
            <div class="wp-p-share-instagram">
              <img src="@/assets/img/icons/iconfinder-38-instagram-1161954@3x.png">
              <div class="share-text">PAYLAŞ</div>
            </div>
          </a>
        </div>
        <div class="wp-p-reset" @click="resetWaterPrint">« Baştan Hesapla</div>
      </div>
    </div>
    <WaterPrintDrop :water-print-index="answerIndex" :water-print-length="Object.keys(answerList).length"/>
  </div>
</template>

<script>
import EventBus from "../main";
import WaterPrintDrop from "./WaterPrintDrop";
import axios from "axios";
export default {
  props: ['msg'],
  name: "WaterPrint",
  data() {
    return {
      promiseResultToken: '',
      answerIndex: 0,
      answerList: {
        0: {
          identifier: 'question-0',
          type: 'select',
          question: 'Yaşadığınız İl',
          answers: [{
            "id": 34,
            "name": "İstanbul",
            "value": 66
          },{
            "id": 6, "name": "Ankara", "value": 79
            },
            {"id": 35, "name": "İzmir", "value": 61},
          {"id": 1, "name": "Adana", "value": 74}, {
            "id": 2,
            "name": "Adıyaman",
            "value": 61
          }, {"id": 3, "name": "Afyonkarahisar", "value": 59}, {
            "id": 4,
            "name": "Ağrı",
            "value": 104
          }, {"id": 68, "name": "Aksaray", "value": 69}, {
            "id": 5,
            "name": "Amasya",
            "value": 87
          },  {
            "id": 7,
            "name": "Antalya",
            "value": 103
          }, {"id": 75, "name": "Ardahan", "value": 143}, {
            "id": 8,
            "name": "Artvin",
            "value": 76
          }, {"id": 9, "name": "Aydın", "value": 82}, {
            "id": 10,
            "name": "Balıkesir",
            "value": 83
          }, {"id": 74, "name": "Bartın", "value": 74}, {
            "id": 72,
            "name": "Batman",
            "value": 119
          }, {"id": 69, "name": "Bayburt", "value": 36}, {
            "id": 11,
            "name": "Bilecik",
            "value": 59
          }, {"id": 12, "name": "Bingöl", "value": 76}, {
            "id": 13,
            "name": "Bitlis",
            "value": 121
          }, {"id": 14, "name": "Bolu", "value": 51}, {
            "id": 15,
            "name": "Burdur",
            "value": 67
          }, {"id": 16, "name": "Bursa", "value": 57}, {
            "id": 17,
            "name": "Çanakkale",
            "value": 63
          }, {"id": 18, "name": "Çankırı", "value": 97}, {
            "id": 19,
            "name": "Çorum",
            "value": 67
          }, {"id": 20, "name": "Denizli", "value": 81}, {
            "id": 21,
            "name": "Diyarbakır",
            "value": 47
          }, {"id": 81, "name": "Düzce", "value": 63}, {
            "id": 22,
            "name": "Edirne",
            "value": 74
          }, {"id": 23, "name": "Elazığ", "value": 71}, {
            "id": 24,
            "name": "Erzincan",
            "value": 84
          }, {"id": 25, "name": "Erzurum", "value": 108}, {
            "id": 26,
            "name": "Eskişehir",
            "value": 63
          }, {"id": 27, "name": "Gaziantep", "value": 118}, {
            "id": 28,
            "name": "Giresun",
            "value": 78
          }, {"id": 29, "name": "Gümüşhane", "value": 42}, {
            "id": 30,
            "name": "Hakkari",
            "value": 42
          }, {"id": 31, "name": "Hatay", "value": 64}, {
            "id": 76,
            "name": "Iğdır",
            "value": 46
          }, {"id": 32, "name": "Isparta", "value": 79},   {
            "id": 46,
            "name": "Kahramanmaraş",
            "value": 108
          }, {"id": 78, "name": "Karabük", "value": 111}, {
            "id": 70,
            "name": "Karaman",
            "value": 49
          }, {"id": 36, "name": "Kars", "value": 147}, {
            "id": 37,
            "name": "Kastamonu",
            "value": 71
          }, {"id": 38, "name": "Kayseri", "value": 79}, {
            "id": 71,
            "name": "Kırıkkale",
            "value": 55
          }, {"id": 39, "name": "Kırklareli", "value": 71}, {
            "id": 40,
            "name": "Kırşehir",
            "value": 96
          }, {"id": 79, "name": "Kilis", "value": 109}, {
            "id": 41,
            "name": "Kocaeli",
            "value": 83
          }, {"id": 42, "name": "Konya", "value": 70}, {
            "id": 43,
            "name": "Kütahya",
            "value": 61
          }, {"id": 44, "name": "Malatya", "value": 105}, {
            "id": 45,
            "name": "Manisa",
            "value": 62
          }, {"id": 47, "name": "Mardin", "value": 104}, {
            "id": 33,
            "name": "Mersin",
            "value": 83
          }, {"id": 48, "name": "Muğla", "value": 84}, {"id": 49, "name": "Muş", "value": 116}, {
            "id": 50,
            "name": "Nevşehir",
            "value": 76
          }, {"id": 51, "name": "Niğde", "value": 61}, {"id": 52, "name": "Ordu", "value": 99}, {
            "id": 80,
            "name": "Osmaniye",
            "value": 62
          }, {"id": 53, "name": "Rize", "value": 73}, {
            "id": 54,
            "name": "Sakarya",
            "value": 120
          }, {"id": 55, "name": "Samsun", "value": 77}, {
            "id": 56,
            "name": "Siirt",
            "value": 91
          }, {"id": 57, "name": "Sinop", "value": 129}, {
            "id": 58,
            "name": "Sivas",
            "value": 111
          }, {"id": 63, "name": "Şanlıurfa", "value": 60}, {
            "id": 73,
            "name": "Şırnak",
            "value": 33
          }, {"id": 59, "name": "Tekirdağ", "value": 62}, {
            "id": 60,
            "name": "Tokat",
            "value": 69
          }, {"id": 61, "name": "Trabzon", "value": 119}, {
            "id": 62,
            "name": "Tunceli",
            "value": 102
          }, {"id": 64, "name": "Uşak", "value": 63}, {"id": 65, "name": "Van", "value": 80}, {
            "id": 77,
            "name": "Yalova",
            "value": 134
          }, {"id": 66, "name": "Yozgat", "value": 86}, {"id": 67, "name": "Zonguldak", "value": 84}],
          value: '',
          image: 'drop.png'
        },
        1: {
          identifier: 'question-1',
          type: 'radio',
          question: 'Haftada kaç kere duş alıyorsunuz?',
          value: '',
          image: 'icon-shower.png',
          answers: [
            {text: '1', value: '1'},
            {text: '2', value: '2'},
            {text: '3', value: '3'},
            {text: '4', value: '4'},
            {text: '5', value: '5'},
            {text: '6', value: '6'},
            {text: '7+', value: '7'},
            ]
        },
        2: {
          identifier: 'question-2',
          type: 'radio',
          question: 'Ortalama duş süreniz?',
          answers: [
            {text: '5 DK', value: '0'},
            {text: '5-20 DK', value: '1'},
            {text: '21-30 DK', value: '2'},
            {text: '30+ DK', value: '3'}
          ],
          value: '',
          image: 'icon-shower.png'
        },
        3: {
          identifier: 'question-3',
          type: 'radio',
          question: 'Çamaşırlarınızı nasıl yıkıyorsunuz?',
          answers: [
            {text: 'Çamaşır Makinesi', value: '0'},
            {text: 'Elde Yıkama', value: '1'}
          ],
          value: '',
          image: 'icon-washing-machine.png'
        },
        4: {
          identifier: 'question-4',
          type: 'radio',
          question: 'Haftada kaç kere çamaşır yıkıyorsunuz?',
          value: '',
          image: 'icon-t-shirt.png',
          answers: [
            {text: '1', value: '1'},
            {text: '2', value: '2'},
            {text: '3', value: '3'},
            {text: '4', value: '4'},
            {text: '5', value: '5'},
            {text: '6', value: '6'},
            {text: '7+', value: '7'},
            ],
        },
        5: {
          identifier: 'question-5',
          type: 'radio',
          question: 'Bulaşıklarınızı nasıl yıkıyorsunuz?',
          answers: [
            {text: 'Bulaşık Makinesi', value: '0'},
            {text: 'Elde Yıkama', value: '1'}
          ],
          value: '',
          image: 'icon-dishwasher.png'
        },
        6: {
          identifier: 'question-6',
          type: 'radio',
          question: 'Haftada kaç kez bulaşık yıkıyorsunuz?',
          value: '',
          image: 'icon-plate.png',
          answers: [
            {text: '1', value: '1'},
            {text: '2', value: '2'},
            {text: '3', value: '3'},
            {text: '4', value: '4'},
            {text: '5', value: '5'},
            {text: '6', value: '6'},
            {text: '7+', value: '7'},
            ],
        },
        7: {
          identifier: 'question-7',
          type: 'radio',
          question: 'Bulaşıklarınızı makineye atmadan önce sudan geçiriyor musunuz?',
          answers: [
            {text: 'Evet', value: '0'},
            {text: 'Hayır', value: '1'}
          ],
          value: '',
          image: 'icon-tap-plate.png'
        },
        8: {
          identifier: 'question-8',
          type: 'radio',
          question: 'Mutfak musluklarını bir günde ne kadar süre kullanıyorsunuz?',
          answers: [
            {text: '5 DK', value: '0'},
            {text: '5-20 DK', value: '1'},
            {text: '21-45 DK', value: '2'},
            {text: '45+ DK', value: '3'}
          ],
          value: '',
          image: 'icon-tap-water.png'
        },
        9: {
          identifier: 'question-9',
          type: 'radio',
          question: 'Aracınız varsa ayda kaç kez yıkatıyorsunuz?',
          value: '',
          image: 'icon-car.png',
          answers: [
            {text: '1', value: '1'},
            {text: '2', value: '2'},
            {text: '3', value: '3'},
            {text: '4', value: '4'},
            {text: '5', value: '5'},
            {text: '6', value: '6'},
            {text: '7+', value: '7'},
            ],
        },
        10: {
          identifier: 'question-10',
          type: 'radio',
          question: 'Aylık yaklaşık mutfak gideriniz (hane)',
          value: '',
          image: 'icon-food-2.png',
          answers: [
            {text: '800 TL', value: '800'},
            {text: '1200 TL', value: '1200'},
            {text: '1800 TL', value: '1800'},
            {text: '2500 TL', value: '2500'},
            {text: '3000 TL+', value: '3000'},
            ],
        },
        11: {
          identifier: 'question-11',
          type: 'radio',
          question: 'Haftalık kırmızı et tüketiminiz (kg)',
          value: '',
          image: 'icon-food.png',
          answers: [
            {text: '0', value: '0'},
            {text: '0-1 KG', value: '0.5'},
            {text: '1-2 KG', value: '1.5'},
            {text: '2-3 KG', value: '2.5'},
            {text: '3 KG+', value: '3'},
            ],
        },
        12: {
          identifier: 'question-12',
          type: 'radio',
          question: 'Günde kaç bardak kahve içersiniz?',
          value: '',
          image: 'kahve-ikon-yeni.png',
          answers: [
            {text: '0', value: '0'},
            {text: '1-3', value: '2'},
            {text: '4-6', value: '5'},
            {text: '6+', value: '6'},
            ],
        },
        13: {
          identifier: 'question-13',
          type: 'radio',
          question: 'Şekerli mi, şekersiz mi?',
          answers: [
            {text: 'Şekerli', value: '0'},
            {text: 'Şekersiz', value: '1'}
          ],
          value: '',
          image: 'icon-sugar.png'
        },
        14: {
          identifier: 'question-14',
          type: 'radio',
          question: '1 bardak çaya kaç adet şeker (adet)?',
          value: '',
          image: 'icon-sugar.png',
          answers: [
            {text: 'Yarım', value: '0.5'},
            {text: '1', value: '1'},
            {text: '2', value: '2'},
            {text: '3+', value: '3'},
            ],
        },
        15: {
          identifier: 'question-15',
          type: 'radio',
          question: 'Aylık kıyafet alışverişi gideriniz (TL)',
          value: '',
          image: 'icon-t-shirt.png',
          answers: [
            {text: '200 TL', value: '200'},
            {text: '500 TL', value: '500'},
            {text: '1000 TL', value: '1000'},
            {text: '2000 TL', value: '2000'},
            {text: '3000 TL+', value: '3000'},
            ],
        }
      },
      answerValues: [],
      answerTarget: null,
      invalidInput: false,
      answersDone: false,
      promiseMade: false,
      promiseMadeOptions: [
        {
          id: "pmo_0",
          text: "Duşta geçirdiğim süreyi 5 dakikaya indireceğime söz veriyorum.",
          subtext: "Duşta 10 dk'da 120 litre su harcanıyor.",
          callback: (target) => {
            target ?
                (this.answerValues[1] = "3", this.answerValues[2] = "0")
                :
                (this.answerValues[1] = this.answerList[1].value, this.answerValues[2] = this.answerList[2].value)
          },
          display: ''
        },
        {
          id: "pmo_1",
          text: "Çamaşır makinesini tam dolu ve ön yıkamasız çalıştıracağıma söz veriyorum.",
          subtext: "Çamaşırları ön yıkamadan geçirmek yaklaşık 10 litre fazladan su harcamanıza neden olur.",
          callback: (target) => {
            target ?
                (this.answerValues[3] = "0", this.answerValues[4] = "0.5")
                :
                (this.answerValues[3] = this.answerList[3].value, this.answerValues[4] = this.answerList[4].value)
          },
          display: ''
        },
        {
          id: "pmo_2",
          text: "Bulaşıklarımı bulaşık makinesine atmadan önce sudan geçirmeyeceğime söz veriyorum.",
          subtext: "Bulaşıkları makineye atmadan önce sudan geçirmek yaklaşık 57 litre fazladan su harcamanıza neden olur.",
          callback: (target) => {
            target ? this.promiseOptionValues.extra_1 = 54 : this.promiseOptionValues.extra_1 = 0;
          },
          display: ''
        },
        {
          id: "pmo_3",
          text: "Kıyafet masrafımı yarıya indireceğime söz veriyorum.",
          subtext: "Bir tişört üretmek için harcanan su miktarı 2700 litredir.",
          callback: (target) => {
            target ? this.answerValues[15] = this.answerList[15].value / 2 : this.answerValues[15] = this.answerList[15].value;
          },
          display: ''
        },
        {
          id: "pmo_4",
          text: "Otomobilimi iki haftada bir yıkayacağıma söz veriyorum.",
          subtext: "Bir yıkamada harcanan su miktarı yaklaşık 12 litredir.",
          callback: (target) => {
            target ? this.answerValues[9] = '2' : this.answerValues[9] = this.answerList[9].value;
          },
          display: ''
        },
        {
          id: "pmo_5",
          text: "Mutfak musluklarının kullandığım süreyi yarıya indireceğime söz veriyorum.",
          subtext: "",
          callback: (target) => {
            target ? this.promiseOptionValues.extra_2 = 64 : this.promiseOptionValues.extra_2 = 0;
          },
          display: ''
        },
        {
          id: "pmo_6",
          text: "Haftalık et tüketimimi yarı yarıya indireceğime söz veriyorum.",
          subtext: "Bir hamburger 2331 litre suya denk gelir.",
          callback: (target) => {
            target ? this.promiseOptionValues.extra_3 = 1250 : this.promiseOptionValues.extra_3 = 0;
          },
          display: ''
        }
      ],
      promiseOptionValues: {extra_1: 0, extra_2: 0, extra_3: 0},
      promiseInvalid: false,
      result: 0,
      realSaved: false,
      realResult: 0,
      allowedKeys: [37, 38, 39, 40, 8, 46, 9, 16],
      allowedKeysSemantic: [],
      socialShareOptions: [
        {
          network: 'facebook',
          hashtags: '',
          title: encodeURIComponent('Söz verdim! FINISH | Yarının Suyu'),
          button: {
            image: require('@/assets/img/icons/facebook-2@3x.png'),
            class: 'wp-p-share-facebook'
          }
        },
        {
          network: 'twitter',
          hashtags: '',
          title: 'Söz verdim! FINISH | Yarının Suyu',
          button: {
            image: require('@/assets/img/icons/share-twitter-icon.png'),
            class: 'wp-p-share-facebook'
          }
        }
      ],
      socialShareImages: {
        website: {
          svg: null,
          image: null,
        }
      }
    }
  },
  mounted() {
    if(window.location.pathname == '/tskb'){
      $('.navigation-main a.router-link-active.home-screen').removeClass('home-screen');
    }
  },
  computed: {
    promiseOptionTotal() {
      let total = 0;
      for (let optionValue in this.promiseOptionValues) {
        total += this.promiseOptionValues[optionValue];
      }
      return total;
    },
    promiseAfter() {
      return this.result - this.promiseOptionTotal;
    },
    shareResult() {
      return parseInt(this.realResult) - parseInt(this.promiseAfter);
    },
    shareUrl() {
      if(window.location.pathname == '/tskb') {  
        dataLayer.push({'event': 'promiseSubmit','liter':this.getShareResult(), 'isTSKB': true })
      } else {
        dataLayer.push({'event':'promiseSubmit','liter':this.getShareResult()})
      }
      
      const params = new URLSearchParams();
            params.append("username", "apiuser@yarininsuyu.com");
            params.append("password", "VAv3dNfmyogCXxw9Fdi8vUBHuiqT24NVVxp0jmlvV2o=");
            params.append("grant_type", "password");
            var data = JSON.stringify({
              "Liter": this.getShareResult()
            });
            axios.post(window.location.origin+"/oauth/token", params, {
                headers: {
                    "Content-Type": "application/x-www-form-urlencoded",
                },
                })
                .then((response) => {
                  this.promiseResultToken = response.data.access_token;
                  
                  var config = {
                        method: 'post',
                        url: window.location.origin+'/api/WaterPrint/Add',
                        headers: { 
                            'Authorization': `Bearer ${response.data.access_token}`,
                            'Content-Type': 'application/json'
                        },
                        data: data
                    };
                    axios(config)
                    .then(function (response) {
                      EventBus.$emit('update-ton', response.data.model.Ton,response.data.model.Count)
                    })
                })
      return window.origin + '?share=social&score=' + this.getShareResult() + '&language=&v=1.1';
    },
    getShareDescription() {
      return encodeURIComponent('Artık ' + this.getShareResult() + ' lt daha az su tüketiyorum.');
    },
  },
  methods: {
    promiseImage() {
      return {
        img: {
          width: 500,
          height: 500,
          location: '/img/social/share-img.jpg'
        },
        text: {
          x: '2%',
          y: '38%',
          value: this.result - this.promiseAfter,
          style: 'font-size: 7em;'
        },
        description: {
          x: '20%',
          y: '50.8%',
          value: this.result - this.promiseAfter,
          style: 'font-size: 1em'
        }
      }
    },
    getShareUrl() {
      return window.origin + '?op=share&share=social&score=' + this.getShareResult() + '&language=&v=1.1';
    },
    saveRealResult(value) {
      !this.realSaved ? this.realResult = value : false;
    },
    instagramShare() {
      window.open(`https://www.yarininsuyu.com/ajax/index?type=instagram&score=${this.getShareResult()}&language=&v=1.1`)
    },
    promiseShareOptions() {
      let promiseOptionValidate = document.querySelectorAll(".wp-promise-form input[type='checkbox']:checked");
      const invalidPromise = () => {
        this.promiseInvalid = true;
        setTimeout(() => {
          this.promiseInvalid = false;
        }, 800);
      }
      promiseOptionValidate && promiseOptionValidate.length > 0 ? this.promiseMade = true : invalidPromise();
    },
    getShareResult() {
      return parseInt(this.realResult) - parseInt(this.promiseAfter);
    },
    refreshResult() {
      for (let savingAnswers of this.promiseMadeOptions) {
        savingAnswers.callback(document.getElementById(savingAnswers.id).checked);
      }
      this.calculateAnswers();
    },
    checkLegitType(value) {
      this.pushAnswer(value.target.id, this.answerIndex);

      /*if (!this.allowedKeys.includes(value.keyCode)) {
          value.preventDefault();
          let numberCheck = RegExp('[0-9]');
          numberCheck.test(value.key) ? value.path[0].value += value.key : value.path[0].value += '';
          this.pushAnswer(value.path[0].id, this.answerIndex);
      }

      if (value.key === 'Enter') {
          this.pushAnswer(value.path[0].id, this.answerIndex);
      }

      if (value.key === '.' || value.key === ',') {
          if (!value.path[0].value.includes('.'))
              value.path[0].value += '.';
      }*/
    },
    invalidInputPrompt() {
      this.invalidInput = true;
      setTimeout(() => {
        this.invalidInput = false;
      }, 500);
    },
    submitAnswer() {
      if (this.answerTarget !== null) {
        let valueTarget = document.getElementById(this.answerTarget.element),
            valueIndex = this.answerTarget.answerIndex,
            pushTo = () => {
              this.answerList[valueIndex].value = valueTarget.value;
              this.answerValues[valueIndex] = valueTarget.value;
              this.answerIndex < Object.keys(this.answerList).length - 1 ? this.answerIndex++ : this.calculateAnswers();
              if(this.answerIndex != 1){
                dataLayer.push({'event':'Step'+(this.answerIndex),'answer':this.answerValues[valueIndex]});
              }else {
                let city = $('#question-0 option:selected').text().trim();
                dataLayer.push({'event':'Step'+(this.answerIndex),'answer': city})
              }
            };

        if (valueTarget.getAttribute('type') === 'number' && valueTarget.value === '') {
          invalidInput();
          return false;
        } else if (valueTarget.nodeName === 'SELECT' && valueTarget.value === 'null') {
          invalidInput();
          return false;
        } else {
          pushTo();
        }
        this.answerTarget = null;
        if(this.answerIndex === 13 && this.answerList[12].value == '0') {
          this.answerList[13].value = '1';
          this.answerValues[13] = '1';
          this.answerIndex++;
        }
        if (this.answerIndex === 14 && this.answerList[13].value === '1') {
          this.answerList[14].value = '0';
          this.answerValues[14] = '0';
          this.answerIndex++;
        } else { 
          return false;
        }
      } else {
        this.invalidInputPrompt();
      }
    },
    previousQuestion() {
      if (this.answerIndex === 15 && this.answerList[13].value === '1') {
        this.answerIndex--;
      }
      if(this.answerIndex === 14 && this.answerList[12].value === '0'){
        this.answerIndex--;
      }
      if (this.answerIndex > 0) {
        this.answerIndex--;
      }
    },
    closeWaterPrint() {
      EventBus.$emit('water-print-status');
      dataLayer.push({'event':'promiseCloseQuiz'})
      $('#home-container').show();
      if(window.location.pathname == '/tskb') {
        this.$router.push({name: "Home"})
      }
      

    },
    pushAnswer(domElement, answerIndex) {
      this.answerTarget = {element: domElement, answerIndex: answerIndex}
    },
    resetWaterPrint() {
      this.answersDone = this.promiseMade = false;
      this.promiseOptionValues = {extra_1: 0, extra_2: 0, extra_3: 0}
      this.answerIndex = 0;
      this.realSaved = false;
      dataLayer.push({'event':'resetPromise'});
    },
    calculateAnswers() {
      this.answersDone = true;

      this.answerList[2].value > 3 ?
          this.promiseMadeOptions[0].display = 'hide' :
          this.promiseMadeOptions[0].display = '';

      this.answerList[3].value != 0 ?
          this.promiseMadeOptions[1].display = 'hide' :
          this.promiseMadeOptions[1].display = '';

      this.answerList[10].value > 2 ?
          this.promiseMadeOptions[4].display = 'hide' :
          this.promiseMadeOptions[4].display = '';

      this.answerList[7].value == 1 ?
          this.promiseMadeOptions[2].display = 'hide' :
          this.promiseMadeOptions[2].display = '';

      this.answerList[11].value == 0 ?
          this.promiseMadeOptions[6].display = 'hide' :
          this.promiseMadeOptions[6].display = '';
          
      this.answerList[2].value == 0 ?
          this.promiseMadeOptions[0].display = 'hide' :
          this.promiseMadeOptions[0].display = '';

      let city = this.answerValues[0],
          people = 1,
          shower_how_many_times = parseFloat(this.answerValues[1]),
          shower_how_long = parseFloat(this.answerValues[2]),
          washing_how = parseFloat(this.answerValues[3]),
          washing_how_many_times = parseFloat(this.answerValues[4]),
          dishwashing_how = parseFloat(this.answerValues[5]),
          dishwhasing_how_many_times = parseFloat(this.answerValues[6]),
          dishwasing_extra_water = parseFloat(this.answerValues[7]),
          kitchen_tap_usage = parseFloat(this.answerValues[8]),
          car_wash_how_many_times = parseFloat(this.answerValues[9]),
          food_cost = parseFloat(this.answerValues[10]),
          meat_consume = parseFloat(this.answerValues[11]),
          tea_consume = parseFloat(this.answerValues[12]),
          how_much_sugar = parseFloat(this.answerValues[14]),
          clothing = parseFloat(this.answerValues[15]);
      debugger;
      let total = 0,
          city_based_total = city,
          shower_based_total = 0,
          washing_based_total = 0,
          dishwashing_based_total = 0,
          dishwashing_extra_water_based_total = 0,
          kitchen_tap_usage_based_total = 0,
          car_wash_based_total = 0,
          food_cost_based_total = 0,
          meat_consume_cost_based_total = 0,
          tea_consume_cost_based_total = 0,
          how_much_sugar_based_total = 0,
          clothing_based_total = 0;

      switch (shower_how_long) {
        case 0:
          shower_based_total = 25 * shower_how_many_times / 7;
          break;
        case 1:
          shower_based_total = 100 * shower_how_many_times / 7;
          break;
        case 2:
          shower_based_total = 250 * shower_how_many_times / 7;
          break;
        case 3:
          shower_based_total = 350 * shower_how_many_times / 7;
          break;
      }

      shower_based_total += shower_based_total * 1.6;

      //shower

      //washing

      switch (washing_how) {
        case 0:
          washing_based_total = 90 * washing_how_many_times / 7 / people;
          break;
        case 1:
          washing_based_total = 100 * washing_how_many_times / 7 / people;
          break;
      }

      washing_based_total += washing_based_total * 1.7;

      //washing

      //dishwashing
      switch (dishwashing_how) {
        case 0:
          dishwashing_based_total = 60 * dishwhasing_how_many_times / 7 / people;
          break;
        case 1:
          dishwashing_based_total = 100 * dishwhasing_how_many_times / 7 / people;
          break;
      }

      switch (dishwasing_extra_water) {
        case 0:
          dishwashing_extra_water_based_total = 60 * dishwhasing_how_many_times / 7 / people;
          break;
      }

      dishwashing_based_total += dishwashing_based_total * 1.7;
      dishwashing_extra_water_based_total += dishwashing_extra_water_based_total * .2;
      //dishwashing

      //kitchen_tap_usage

      switch (kitchen_tap_usage) {
        case 0:
          kitchen_tap_usage_based_total = 12.5 / people;
          break;
        case 1:
          kitchen_tap_usage_based_total = 62.5 / people;
          break;
        case 2:
          kitchen_tap_usage_based_total = 150 / people;
          break;
        case 3:
          kitchen_tap_usage_based_total = 225 / people;
          break;
      }

      kitchen_tap_usage_based_total += kitchen_tap_usage_based_total * 0.2;

      //kitchen_tap_usage

      //car_wash_how_many_times
      car_wash_based_total = 300 / 7 * car_wash_how_many_times / people;
      car_wash_based_total += car_wash_based_total * 1.2;
      //car_wash_how_many_times

      //food_cost
      food_cost_based_total = food_cost * 0.315 + food_cost * 0.34 + food_cost * 0.027;
      //food_cost

      //food_cost
      meat_consume_cost_based_total = meat_consume * 13909.5 / 7 / people + meat_consume * 627 / 7 / people;
      //food_cost

      //food_cost
      tea_consume_cost_based_total = tea_consume * 2296 * 2 / 1000 + tea_consume * 735 * 2 / 1000;
      //food_cost

      //food_cost
      how_much_sugar_based_total = how_much_sugar * 364 * 0.4 / 1000 * tea_consume + how_much_sugar * 577 * 0.4 / 1000 * tea_consume;
      //food_cost

      //clothing
      clothing_based_total = 10 * clothing / 30 / people + 4 * clothing / 30 / people + 3 * clothing / 30 / people;
      //clothing

      debugger;
      total += Math.round(city_based_total);
      total += Math.round(shower_based_total);
      total += Math.round(washing_based_total);
      total += Math.round(dishwashing_based_total);
      total += Math.round(dishwashing_extra_water_based_total);
      total += Math.round(kitchen_tap_usage_based_total);
      total += Math.round(car_wash_based_total);
      total += Math.round(food_cost_based_total);
      total += Math.round(meat_consume_cost_based_total);
      total += Math.round(tea_consume_cost_based_total);
      total += Math.round(how_much_sugar_based_total);
      total += Math.round(clothing_based_total);
      
      this.result = total;
      this.saveRealResult(total);
      this.realSaved = true;
    }
  },
  created() {
    EventBus.$emit('menu-status', false);
    console.log(process.env.SHARE_URL);
  },
  components: {
    WaterPrintDrop
  }
}

</script>

<style lang="scss">
.wp-a-s-button-icon {
  width: 10px;
  height: 10px;
  display: flex;
  margin-right: 5px;
}
.wp-a-s-button-icon-right {
  margin-left: 5px;
  transform: rotate(180deg);
}
.wp-a-s-button-icon svg {
  width: 100%;
  fill: #00a0e2;
}
.promise-image__description {
  font-size: 1em !important;
  font-weight: normal !important;
}

#water-print {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.5);
  width: 100%;
  height: 100%;
  z-index: 20;

  .wp-close {
    max-width: 520px;
    width: 90%;
    display: flex;
    margin-bottom: 10px;

    img {
      object-fit: contain;
      height: 100%;
      margin-left: auto;
      cursor: pointer;
    }
  }

  .wp-main-content {
    max-width: 520px;
    width: 90%;
    height: auto;
    max-height: 80vh;
    border-radius: 3px;
    background-color: #ffffff;
    display: flex;
    flex-direction: column;
    position: relative;
    overflow-y: auto;

    .wp-header {
      color: black;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      max-width: 60%;
      text-align: center;
      margin: 20px auto 30px auto;

      .wp-h-title {
        font-size: 1.5em;
        font-weight: bold;
        margin-bottom: 25px;
      }
    }

    .wp-image {
      display: flex;
      justify-content: center;
      min-height: 90px;
      max-height: 90px;

      img {
        object-fit: contain;
      }
    }

    .wp-question {
      display: flex;
      color: black;
      font-size: 12px;
      font-weight: normal;
      font-stretch: normal;
      font-style: normal;
      text-align: center;
      justify-content: center;
      align-items: center;
      width: 90%;
      margin: 0 auto;
      height: 50px;
    }
    
    .wp-answers {
      display: flex;
      justify-content: center;
      align-items: center;
      width: calc(100% - 90px);
      margin: 0 auto 20px auto;
      height: 40px;

      .wp-a-radio-container {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 39px;
        border: 1px solid #00a0e2;
        border-right: none;

        &:first-of-type {
          border-radius: 3px 0 0 3px;
        }

        &:last-of-type {
          border-right: 1px solid #00a0e2;
          border-radius: 0 3px 3px 0;
        }

        label {
          background: white;
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          font-size: 12px;
          font-weight: bold;
          font-stretch: normal;
          font-style: normal;
          color: #4a4a4a;

          &:hover {
            background: #00a0e2;
            color: white;
          }
        }

        input {
          display: none;
        }

        input[type="radio"]:checked {
          background: #00a0e2;

          & + label {
            background: #00a0e2;
            color: white;
          }
        }
      }

      input[type="text"],
      input[type="tel"],
      input[type="number"],
      select {
        text-align: center;
        border: 1px solid #00a0e2;
        padding: 10px;
        border-radius: 45px;
        outline: none;
      }

      /* Chrome, Safari, Edge, Opera */
      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      /* Firefox */
      input[type=number] {
        -moz-appearance: textfield;
      }

      select {
        cursor: pointer;
        padding-right: 5px;
      }
    }

    .wp-answer-submit {
      color: #00a0e2;
      display: flex;
      flex-direction: column;

      .wp-a-s-button {
        width: 160px;
        padding: 8px 0;
        border: 1px #00a0e2 solid;
        cursor: pointer;
        text-align: center;
        margin: 0 auto 20px auto;
        border-radius: 50px;
        transition: background-color 400ms ease-in-out;
        display: flex;
        align-items: center;
        justify-content: center;
        &:nth-of-type(1) {
          background: #00a0e2;
          color: white;
        }

        &.invalid {
          background-color: #ac1531;
          border-color: #ac1531;
        }
      }
    }

    .wp-result-container {
      display: flex;
      flex-direction: column;
      width: calc(100% - 10px);
      height: 100%;
      justify-content: center;
      align-items: center;
      color: black;
      margin: auto;
      text-align: center;
      padding-bottom: 50px;

      .result {
        font-size: 24px;
        font-weight: bold;
        margin-top: 15px;
        margin-bottom: 10px;

        .inline {
          display: inline-block;
          font-weight: bolder;
          font-size: 45px;
          color: #af0000;
        }
      }

      .wp-promise-form {
        width: 90%;

        .wp-p-item {
          display: flex;
          align-items: flex-start;
          width: 100%;
          position: relative;
          margin-bottom: 5px;

          &.hide {
            display: none;
          }

          input {
            position: absolute;
            opacity: 0;
            cursor: pointer;
            display: block;
            background: transparent;
            border: 1px solid #00a259;
            padding: 15px 20px;
            border-radius: 30px;
            width: 100%;
            height: 100%;
            margin: 0;
            outline: none;
            font-size: 1.3em;
            font-weight: 700;
            box-sizing: border-box;
            z-index: 1;

            &:checked ~ .checkmark {
              background-color: #00abe9;
            }
          }

          .checkmark {
            position: absolute;
            top: 0;
            left: 0;
            height: 18px;
            width: 18px;
            background-color: transparent;
            border: 2px solid black;
            border-radius: 50%;
          }

          .checkbox-cont {
            margin-bottom: 5px;
            margin-left: 35px;

            p {
              margin: 0;
              text-align: left;

              &:first-of-type {
                font-weight: bold;
              }
            }
          }
        }
      }

      .wp-promise-submit-container {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        position: relative;
        height: 60px;

        .wp-p-reset {
          font-size: 12px;
          font-weight: bold;
          color: #00bfed;
          width: 110px;
          min-width: 110px;
          max-width: 110px;
          cursor: pointer;
          margin: auto auto auto 10px;
        }

        .wp-p-submit {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 233px;
          min-width: 233px;
          max-width: 233px;
          height: 44px;
          border: 1px solid #00bfed;
          border-radius: 45px;
          font-size: 12px;
          font-weight: bold;
          color: #00bfed;
          cursor: pointer;
          position: absolute;
          left: 50%;
          transform: translateX(-50%);
          transition: all 300ms ease-in-out;

          &:hover {
            background-color: #00bfed;
            color: white;
          }

          &.invalid-promise {
            background-color: #ac1531;
            border-color: #ac1531;
            color: white;
          }
        }
      }
    }

    .wp-promise-made {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      padding: 10px 0;

      .wp-p-reset {
        color: #00a0e2;
        font-weight: bolder;
        margin-bottom: 15px;
        cursor: pointer;
      }

      .wp-p-promise-image {
        display: flex;
        justify-content: center;
        width: 100%;
        height: 100%;
        margin-bottom: 15px;


        svg {
          width: 500px;
          height: 500px;
          min-width: 500px;
          min-height: 500px;
          margin: 0 auto;

          image {
            width: 500px;
            height: 500px;
          }

          text {
            font-size: 6em;
            font-weight: bolder;
          }
        }
      }

      .wp-p-share-options {
        display: flex;
        justify-content: space-around;
        width: 95%;
        margin-bottom: 15px;

        .wp-p-share-option {
          display: flex;
          justify-content: space-around;
          align-items: center;
          width: 150px;
          height: 50px;
          background-color: black;
          border-radius: 50px;
          cursor: pointer;


          &[class*='twitter'] {
            background-color: #3ab0ee;
          }

          &[class*='facebook'] {
            background-color: #4f65ac;
          }

          &[class*='instagram'] {
            background-color: #de31a9;
            text-decoration: none;
          }

          > div[class*='wp-p-share-'],
          > a[class*='wp-p-share-'],
          > a:visited,
          > a:link {
            display: flex;
            align-items: center;
            width: 100%;
            text-decoration: none;

            img {
              width: 25px;
              height: 25px;
              object-fit: contain;
              margin: auto 5px auto 20px;
            }

            .share-text {
              width: 80px;
              text-align: center;
              font-weight: bolder;
              margin: 0;
              padding: 0;
              border: 0;
              font-size: 1.4em;
              vertical-align: baseline;
              color: white;
              text-decoration: none;
            }
          }
        }
      }
    }
  }

  .wp-footer {
    font-weight: bold;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    margin-top: 14px;
  }

  @media only screen and (max-device-width: 768px) {
    .wp-a-s-button-icon {
      width: 20px;
      height: 20px;
      
    }
    .wp-close,
    .wp-main-content,
    .wp-footer {
      max-width: initial;
    }

    .wp-close {
      margin-bottom: 50px;
      height: 60px;
    }

    .wp-main-content {
      min-height: 55vh;

      .wp-header {
        max-width: 90%;
        font-size: 35px;

        .wp-h-title {
          font-size: 1.2em;
        }

        .wp-h-text {
          font-size: 0.8em;
        }
      }

      .wp-questions-container {
        font-size: 40px;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-around;

        .wp-image {
          height: 160px;
          object-fit: contain;
          min-height: initial;
          max-height: initial;
          margin-bottom: 15px;

          img {
            height: 100%;
          }
        }

        .wp-question {
          font-size: 1em;
          margin-bottom: 15px;
          min-height: 160px;
        }

        .wp-answers {
          height: auto;

          select,
          input {
            height: 90px;
            width: 60%;
            font-size: 40px;
            border-radius: 90px;
            border: 5px solid #00a0e2;
            padding: 10px 10px 10px 20px;
            -webkit-appearance: none;
            
            -webkit-border-radius: 90px;
            background-image: url("data:image/svg+xml;utf8,<svg version='1.1' xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' width='50' height='50' viewBox='0 0 24 24'><path fill='%23444' d='M7.406 7.828l4.594 4.594 4.594-4.594 1.406 1.406-6 6-6-6z'></path></svg>");
            background-position: 99% 50%;
            background-repeat: no-repeat;
          }
          
          .wp-a-radio-container {
            height: 90px;
            border: 5px solid #00a0e2;
            border-right: none;

            &:first-of-type {
              border-radius: 3px 0 0 3px;
            }

            &:last-of-type {
              border-right: 5px solid #00a0e2;
              border-radius: 0 3px 3px 0;
            }

            label {
              font-size: 32px;
            }
          }
        }

        .wp-answer-submit {
          .wp-a-s-button {
            width: 50%;
          }
        }
      }

      .wp-promise-made {
        height: 100%;
        padding: 20px 0;
        font-size: 26px;

        .wp-p-promise-image {

          svg {
            width: 85vw;
            height: 85vw;
            min-width: 85vw;
            min-height: 85vw;

            image {
              width: 85vw;
              height: 85vw;
              min-width: 85vw;
              min-height: 85vw;
            }

            text {
              font-size: 10vw;
            }
          }
        }

        .wp-p-share-options {
          .wp-p-share-option {
            width: 250px;
            height: 80px;
            text-decoration: none;

            &:visited,
            &:active {
              text-decoration: none;
              color: white;
            }

            div[class*='wp-p-share-']
            a[class*='wp-p-share-'], {
              img {
                width: 45px;
                height: 45px;
                -o-object-fit: contain;
                object-fit: contain;
                margin: auto 15px auto 20px;
              }

              color: white;
              text-decoration: none;
            }
          }
        }
      }

      .wp-result-container {
        font-size: 32px;

        .result {
          font-size: 45px;
          margin-bottom: 60px;

          .inline {
            font-size: 85px;
          }
        }

        .wp-promise-form .wp-p-item .checkmark {
          top: 10px;
        }

        .wp-promise-submit-container {
          flex-direction: column-reverse;
          height: auto;
          margin-top: 25px;

          .wp-p-reset {
            font-size: 42px;
            width: auto;
            min-width: initial;
            max-width: initial;
            margin: 15px 0 15px 0;
          }

          .wp-p-submit {
            width: auto;
            min-width: initial;
            max-width: initial;
            position: relative;
            left: 0;
            transform: none;
            font-size: 42px;
            padding: 15px 100px;
            height: 94px;
          }
        }
      }
    }
    #water-print-drop {
      width: 100px;
      height: 100px;

      circle {
        stroke-width: 8px;
      }
    }
  }
}
</style>
